import { Nav, Footer } from "@/components/Nav";
import { RefreshCw, Wallet, Shield, XCircle, Sun } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export default function Rimborsi() {
    const { t, lang } = useLang();
    const locale = lang === "en" ? "en-GB" : "it-IT";
    return (
        <div className="min-h-screen bg-[#15181C] text-[#F4F2ED]">
            <Nav />
            <div className="max-w-3xl mx-auto px-5 md:px-8 py-10">
                <div className="text-xs uppercase tracking-[0.3em] text-[#9AA2AD] mb-2">{t("rimborsi.docLabel")}</div>
                <h1 className="font-display text-5xl md:text-6xl uppercase mb-4">{t("rimborsi.title1")}<br /><span className="text-[#E2231A]">{t("rimborsi.title2")}</span></h1>
                <p className="text-[#9AA2AD] mb-10" dangerouslySetInnerHTML={{ __html: t("rimborsi.lead") }} />

                <div className="space-y-4 mb-10">
                    <RuleCard icon={<RefreshCw strokeWidth={1.5} />} title={t("rimborsi.r1t")} tone="default" bodyHtml={t("rimborsi.r1b")} />
                    <RuleCard icon={<Wallet strokeWidth={1.5} />} title={t("rimborsi.r2t")} tone="ok" bodyHtml={t("rimborsi.r2b")} />
                    <RuleCard icon={<RefreshCw strokeWidth={1.5} />} title={t("rimborsi.r3t")} tone="warn" bodyHtml={t("rimborsi.r3b")} />
                    <RuleCard icon={<XCircle strokeWidth={1.5} />} title={t("rimborsi.r4t")} tone="danger" bodyHtml={t("rimborsi.r4b")} />
                    <RuleCard icon={<Sun strokeWidth={1.5} />} title={t("rimborsi.r5t")} tone="ok" bodyHtml={t("rimborsi.r5b")} />
                    <RuleCard icon={<Shield strokeWidth={1.5} />} title={t("rimborsi.r6t")} tone="warn" bodyHtml={t("rimborsi.r6b")} />
                </div>

                <div className="border border-[#E2231A]/40 bg-[#E2231A]/5 p-6 mb-10">
                    <h2 className="font-display text-2xl uppercase mb-3">{t("rimborsi.howTitle")}</h2>
                    <ol className="list-decimal pl-6 space-y-2 text-sm">
                        {["how1","how2","how3","how4"].map(k => (
                            <li key={k} dangerouslySetInnerHTML={{ __html: t("rimborsi." + k) }} />
                        ))}
                    </ol>
                </div>

                <div className="text-xs text-[#9AA2AD] space-y-2">
                    <p dangerouslySetInnerHTML={{ __html: t("rimborsi.footNote") }} />
                    <p>{t("rimborsi.lastUpdate")}: {new Date().toLocaleDateString(locale)}.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
}

const RuleCard = ({ icon, title, bodyHtml, tone }) => {
    const border = {
        ok: "border-[#16a34a]/50",
        warn: "border-[#ca8a04]/50",
        danger: "border-[#E2231A]/50",
        default: "border-[#9AA2AD]/30",
    }[tone];
    return (
        <div className={`border ${border} bg-[#1C2026] p-5 flex gap-4 items-start`}>
            <div className="text-[#E2231A] mt-1 shrink-0">{icon}</div>
            <div>
                <div className="font-display uppercase tracking-widest text-lg mb-1">{title}</div>
                <p className="text-sm text-[#9AA2AD]" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
            </div>
        </div>
    );
};
